// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + chunkId + "." + {"436": "54307cbbcbbdc9fa","755": "4cbfc727ddc8dde4",}[chunkId] + ".css"
}